import { Browser } from "@capacitor/browser";
import { Capacitor } from "@capacitor/core";

/**
 * Opens a URL outside of the app: the OS in-app browser on native, a new tab on the web.
 *
 * Prefer this over rendering the page in an iframe. Plenty of the sites we link out to — and plenty of the sites
 * *they* link out to, such as the state immunization registries linked from our FAQs — send `X-Frame-Options` or a
 * `frame-ancestors` CSP, so the browser refuses to frame them and the user is left staring at a blank page with no
 * way forward or back.
 */
export async function openExternalUrl(url: string): Promise<void> {
  if (Capacitor.isNativePlatform()) {
    await Browser.open({ url });
  } else {
    window.open(url, "_blank", "noopener,noreferrer");
  }
}
